/*** IMPORTS FROM imports-loader ***/
var Promise = require("es6-promise");

"use strict";
function promiseFinally(value, cb) {
    return Promise.resolve(value)
        .then(function (value) { return Promise.resolve(cb()).then(function () { return value; }); }, function (reason) { return Promise.resolve(cb()).then(function () { return Promise.reject(reason); }); });
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = promiseFinally;
//# sourceMappingURL=promise-finally.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/promise-finally/dist/promise-finally.js
// module id = 237
// module chunks = 0